import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {map, tap} from "rxjs/operators";

import { Controller } from "../interface/controller.interface";
import { HTTPMethod } from "../model/http-method.enum";
import { HTTPRequestBuilder } from "../model/http.request.model";
import { CommercialStructure } from "../persistence/dto/commercial-structure.model";
import { CommercialStructureMigration } from "../persistence/view-dto/commercial-structure-migration.model";
import { TypeSystem } from "../support/type-system.support";
import { HTTPService } from "./http.service";

	/**
	 * @description
	 *  Servicio reflejo del controlador de estructuras comerciales del
	 *	backend.
	 *
	 * @see gigot-backend/Core/Controller/CommercialStructureController.cs
	 */

@Injectable({ providedIn: "root" })
export class CommercialStructureService implements Controller {

	constructor(private httpService: HTTPService) {}

	public basePath(): string {
		return "api/commercialStructure";
	}

	public byCampaignId(campaignId: number, isInvoiced: Boolean): Observable<CommercialStructure> {
		return this.httpService.send<typeof undefined, CommercialStructure>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`${campaignId}/${isInvoiced}`)
                .build())
            .pipe(map(commercialStructure => CommercialStructure.from(commercialStructure)));
	}

	public migrate(migration: CommercialStructureMigration): Observable<typeof TypeSystem.EmptyObject> {
		return this.httpService.send<CommercialStructureMigration, null>(
            new HTTPRequestBuilder<CommercialStructureMigration>()
                .method(HTTPMethod.POST)
                .controllerPath(this.basePath())
				.payload(migration)
                .relativePath("migration")
                .build())
			.pipe(map(() => TypeSystem.EmptyObject));
	}
}
